import {ActionBuilder} from "co-redux-builders";
import UndergroundParkTicket from "../../../model/UndergroundParkTicket";

export default ActionBuilder.build({

    setCurrentParkTicket: (currentParkTicket: UndergroundParkTicket) => ({currentParkTicket}),

    clearParkingListViewReducer: () => ({}),
});